import { QuestelServicesClient, HttpMethodEnum } from '@questelservices/common';
import store from '@/store';
import { AnalysisTriggerRuleDto } from '@/models/analysis-triggers/AnalysisTriggerRuleDto';
import { LoadOptions } from 'devextreme/data/load_options';

export class AnalysisTriggerRuleService {
  private readonly client: QuestelServicesClient;

  constructor() {
    this.client = new QuestelServicesClient(store, '/api/AnalysisTriggerRules');
  }

  async list(options: LoadOptions): Promise<any> {
    return await this.client.getPostData('/list', options);
  }

  async get(id: Guid): Promise<AnalysisTriggerRuleDto> {
    return await this.client.get<AnalysisTriggerRuleDto>(`/${id}`);
  }

  async create(data: AnalysisTriggerRuleDto): Promise<AnalysisTriggerRuleDto> {
    return await this.client.getPostData<AnalysisTriggerRuleDto>('', data);
  }

  async update(id: Guid, data: AnalysisTriggerRuleDto): Promise<AnalysisTriggerRuleDto> {
    return await this.client.getData<AnalysisTriggerRuleDto>(HttpMethodEnum.Put, `/${id}`, data);
  }

  async delete(id: Guid): Promise<AnalysisTriggerRuleDto> {
    return await this.client.getData<AnalysisTriggerRuleDto>(HttpMethodEnum.Delete, `/${id}`);
  }
}
